import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import styles from './box-layout.styles';
import SwipeableViews from 'react-swipeable-views';
import Pagination from './common/MUIPagination';
import MainUnitLayout from './Mainunit-layout';
import CoolLayout from './Cool-layout';
import Hd36Layout from './HD36-layout.js';
import L60Layout from './l60-layout.js';
import M22Layout from './Main22-layout';
import M24Layout from './Main24-layout';
import { FastlaneProLayout } from './fastlane-pro';
import PreAssignmentLayout from '../unplugged-assign-prescriptions/pre-assignment-layout';
import C30Layout from './C30.layout.js';
import A12Layout from './A12-layout.js';
import V12Layout from './V12-layout.js';
import Cool12 from './Cool12.js';
import Main41Layout from './Main41-layout.js';
import C28Layout from './C28.layout.js';
import Hd33Layout from './HD33-layout.js';
let deactivatedBin = [];
let selectedTabIndex = 0;
let IsTabSelect = false;

const boxes_type_enum = {
    MAIN: 'd5e3af71-ab56-44c4-bf4d-de7b53e47f38',
    L60: '415f008a-2913-49ea-9c62-e830f2c07008',
    COOL: 'fdfe7cf1-d266-4e1a-b26d-87423ce2b56b',
    HD36: '68534189-6ac4-4fdb-ae16-374d7870fd92',
    M22: 'eb5e33fc-b744-46fb-9ee6-802c602977c1',
    M24: '9fa0079a-3d98-4942-88c8-3f6537d68e48',
    FASTLANE: 'e9da3c38-b838-4054-8b74-dcfb7d2713d8',
    C30: '3c5cd3cd-bf63-4662-81da-a1d68e2e0fcf',
    A12: '6d17b7f1-d107-4d27-af31-c10beed40827',
    V12: '149bf48b-39ff-4c7b-9cc8-df9f24ef871d',
    Cool12: 'c9d0fc90-383d-4e1d-a52c-e98ff42b86cb',
    M41: '4eb90d79-d6fc-4b04-ba06-7b60feb26a61',
    C28: '1c4f111d-722a-4896-952b-31f9119b28a6',
    HD33: '33318078-e5e6-4e11-9dcf-f6ac9145a4be'
};

export class boxLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUnit: Math.max(0, this.props.currentTabIndex || 0)
        }
    }
    handleChangeIndex = index => {
        this.setState({
            selectedUnit: Math.max(0, index)
        });
        selectedTabIndex = Math.max(0, index);
        IsTabSelect = true;
        this.props.getSelectedUnitName(index);
    };

    componentDidMount() {
        IsTabSelect = false;
        const validIndex = Math.max(0, this.props.currentTabIndex || 0);
        this.setState({
            selectedUnit: validIndex
        });
        selectedTabIndex = validIndex;
    }
    componentWillReceiveProps() {
        const nextIndex = Math.max(0, IsTabSelect === false ? (this.props.currentTabIndex || 0) : selectedTabIndex);
        if (nextIndex !== this.state.selectedUnit) {
            this.setState({
                selectedUnit: nextIndex
            });
        }
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                return true
            })
            deactivatedBin = [];
        }
    }
    componentWillUnmount() {
        selectedTabIndex = 0;
        IsTabSelect = false;
    }
    Selectedbin = (binId, position, flag) => {
        this.props.getSelectedBin(binId, position, flag);
    }

    getExpansionUnitsByPos = (position) => {
        const { expansionUnits } = this.props;
        return expansionUnits.filter(x => x.pos === position);
    }

    getExpansionsCounts = () => {
        let boxLeftExpansionObjectArray = [];
        let boxRightExpansionObjectArray = [];
        let RightAndLeftExpansions = {}
        const { expansionUnits } = this.props;
        for (let unit = 0; unit < expansionUnits.length; unit++) {
            if (expansionUnits[unit].box_position < 0) {
                let expansionObj = {
                    expansionId: expansionUnits[unit].id,
                    box_position: Number(expansionUnits[unit].box_position),
                    bin_column_count: expansionUnits[unit].bin_column_count
                }
                if (expansionObj && expansionObj.expansionId && expansionObj.box_position !== 0) {
                    boxLeftExpansionObjectArray.push(expansionObj);
                }
            } else {
                let expansionObj = {
                    expansionId: expansionUnits[unit].id,
                    box_position: Number(expansionUnits[unit].box_position),
                    bin_column_count: expansionUnits[unit].bin_column_count
                }
                if (expansionObj && expansionObj.expansionId && expansionObj.box_position !== 0) {
                    boxRightExpansionObjectArray.push(expansionObj);
                }
            }
        }
        RightAndLeftExpansions.leftExpansions = boxLeftExpansionObjectArray.reverse();
        RightAndLeftExpansions.rightExpansions = boxRightExpansionObjectArray;
        return RightAndLeftExpansions;
    }

    render() {
        const { selectedUnit } = this.state;
        const { boxTypeId, t, allowMultiBinsPickup, is_pre_assignment, is_size_based_pre_assignment, isViewPermissionAllowed, ADAData, PatientID, onBinPositionUpdate } = this.props;
        const useSizeBasedPreAssignLayout = is_size_based_pre_assignment === true;
        let { expansionUnits } = this.props;
        const Expansions = this.getExpansionsCounts();
        if (is_pre_assignment && useSizeBasedPreAssignLayout) {
            expansionUnits = expansionUnits.filter(
                (item) =>
                    item.pos === 'M' ||
                    item.pos === 'M22' ||
                    item.pos === 'M24' ||
                    item.pos === 'M41'
            );
        }
        return (
            <div key="boxInnerLayout" style={{ position: 'relative' }}>
                {!useSizeBasedPreAssignLayout && (
                <Pagination 
                    dots={expansionUnits && expansionUnits.length > 0 ? expansionUnits.length : 0}
                    index={selectedUnit} 
                    onChangeIndex={this.handleChangeIndex} 
                />
                )}
                <SwipeableViews index={useSizeBasedPreAssignLayout ? 0 : selectedUnit} onChangeIndex={this.handleChangeIndex}>
                    {useSizeBasedPreAssignLayout && this.props.BoxID ? (
                        [
                            <PreAssignmentLayout
                                key="size-based-pre-assignment"
                                makeAPICall={this.props.makeAPICall}
                                BoxID={this.props.BoxID}
                                getPrescriptionDetails={this.props.getPrescriptionDetails}
                                getAvailableBinsCount={this.props.getAvailableBinsCount}
                                binSizeByBinId={this.props.binSizeByBinId || {}}
                                t={t}
                                isViewPermissionAllowed={isViewPermissionAllowed}
                            />
                        ]
                    ) : (expansionUnits && expansionUnits !== undefined &&
                        expansionUnits.length > 0) ? (
                        expansionUnits.map((item, index) => {
                            let getExpansionUnits = this.getExpansionUnitsByPos(item.pos);
                            if (item.pos === 'L') {
                                if (item && item.expansion_id === boxes_type_enum.L60) {
                                    return (
                                        <L60Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.HD36) {
                                    return (
                                        <Hd36Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.COOL) {
                                    return (
                                        <CoolLayout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                } else if (item && item.expansion_id === boxes_type_enum.C30) {
                                    return (
                                        <C30Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                } else if (item && item.expansion_id === boxes_type_enum.A12) {
                                    return (
                                        <A12Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.V12) {
                                    return (
                                        <V12Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.Cool12) {
                                    return (
                                        <Cool12
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                if (item && item.expansion_id === boxes_type_enum.C28) {
                                    return (
                                        <C28Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                if (item && item.expansion_id === boxes_type_enum.HD33) {
                                    return (
                                        <Hd33Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                            }
                            if (item.pos === 'M') {
                                return (
                                    <MainUnitLayout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        isADACompatible={this.props.isADACompatible}
                                        deactivatedBins={this.props.deactivatedBins}
                                        ADAData={ADAData}
                                        PatientID={PatientID}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                        columnMappings={this.props.columnMappings || []}
                                        userGroupType={this.props.userGroupType || null}
                                    />
                                )
                            } else if (item.pos === 'M22') {
                                return (
                                    <M22Layout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos + item.selectedUnitIndex}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        deactivatedBins={this.props.deactivatedBins}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        isADACompatible={this.props.isADACompatible}
                                        ADAData={ADAData}
                                        PatientID={PatientID}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                        columnMappings={this.props.columnMappings || []}
                                        userGroupType={this.props.userGroupType || null}
                                    />
                                )
                            } else if (item.pos === 'M24') {
                                return (
                                    <M24Layout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos + item.selectedUnitIndex}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        deactivatedBins={this.props.deactivatedBins}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        columnMappings={this.props.columnMappings || []}
                                        userGroupType={this.props.userGroupType || null}
                                        isADACompatible={this.props.isADACompatible}
                                        ADAData={ADAData}
                                        PatientID={PatientID}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                )
                            } else if (item.pos === 'FASTLANE' || item.pos === 'FASTLANEGOLIATH') {
                                return (
                                    <FastlaneProLayout
                                        key={index}
                                        t={t}
                                        allowMultiBinsPickup={allowMultiBinsPickup}
                                        expansion={item}
                                        prefix={item.pos}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        deactivatedBins={this.props.deactivatedBins}
                                        PatientID={this.props.PatientID}
                                        makeAPICall={this.props.makeFastlaneAPICall}
                                        BoxID={this.props.BoxID}
                                        selectedBox={this.props.selectedBox}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                        onBinPositionUpdate={onBinPositionUpdate}
                                    />
                                )
                            } else if (item.pos === 'M41') {
                                return (
                                    <Main41Layout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos + item.selectedUnitIndex}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        deactivatedBins={this.props.deactivatedBins}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        columnMappings={this.props.columnMappings || []}
                                        userGroupType={this.props.userGroupType || null}
                                        previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                        ExpansionsCounts={Expansions}
                                        ADAData={ADAData}
                                        PatientID={PatientID}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                )
                            }
                            if (item.pos === 'R') {
                                if (item && item.expansion_id === boxes_type_enum.L60) {
                                    return (
                                        <L60Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.HD36) {
                                    return (
                                        <Hd36Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.COOL) {
                                    return (
                                        <CoolLayout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                } else if (item && item.expansion_id === boxes_type_enum.C30) {
                                    return (
                                        <C30Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                } else if (item && item.expansion_id === boxes_type_enum.A12) {
                                    return (
                                        <A12Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.V12) {
                                    return (
                                        <V12Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.Cool12) {
                                    return (
                                        <Cool12
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.C28) {
                                    return (
                                        <C28Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.HD33) {
                                    return (
                                        <Hd33Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            columnMappings={this.props.columnMappings || []}
                                            userGroupType={this.props.userGroupType || null}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            ADAData={ADAData}
                                            PatientID={PatientID}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                            }

                            return null
                        }).filter(child => child != null && child !== true && child !== false)
                    ) : []}
                </SwipeableViews>
            </div>
        );
    }
}

export default withStyles(styles)(boxLayout);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/box-layout.js